// SEC-MQ: 실시간 브로커(STOMP) 접속 자격 증명을 고른다.
// REACT_APP_WS_AUTH_MODE=token이면 공용 브로커 계정 대신 로그인 사용자의 JWT로 접속한다.
// 브로커가 user 모듈에 물어 자기 호텔·여행사(관리자는 관리자용) 라우팅 키만 구독을 허용한다.
// 값이 없으면 기존 공용 계정(REACT_APP_WS_ID/PASSCODE)을 그대로 쓴다.
export const STOMP_TOKEN_USERNAME_PREFIX = 'occ-user-';

// 토큰은 수명이 길어 평문 ws://로 보내면 네트워크에서 탈취될 수 있다.
// 토큰 모드에서는 wss:// 주소(로컬 개발 주소는 예외)일 때만 토큰을 보낸다.
const LOCAL_HOSTS = ['localhost', '127.0.0.1', '[::1]'];

export function isTokenSafeStompUrl(url) {
  if (typeof url !== 'string') return false;
  const trimmed = url.trim().toLowerCase();
  if (trimmed.startsWith('wss://')) return true;
  if (!trimmed.startsWith('ws://')) return false;
  const host = trimmed.slice('ws://'.length).split('/')[0].replace(/:\d+$/, '');
  return LOCAL_HOSTS.includes(host);
}

export function getStompCredentials(
  { userNo, accessToken, url },
  env = process.env,
) {
  if (env.REACT_APP_WS_AUTH_MODE === 'token') {
    if (!isTokenSafeStompUrl(url)) {
      // 토큰을 보내지 않고 빈 값으로 접속을 시도한다. 브로커가 거부하므로 설정 오류가 드러난다.
      console.error('[STOMP] token mode requires a wss:// address');
      return { login: `${STOMP_TOKEN_USERNAME_PREFIX}${userNo}`, passcode: '' };
    }
    return {
      login: `${STOMP_TOKEN_USERNAME_PREFIX}${userNo}`,
      passcode: accessToken,
    };
  }
  return { login: env.REACT_APP_WS_ID, passcode: env.REACT_APP_WS_PASSCODE };
}
